/**
 * 点呼ページ用のスクリプト
 */
if (is_route('rollcall.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        rollcall_event_set();
        rollcall_detail_event_set();
        rollcall_config_event_set();
        // 「検索ボタンを表示する」トグルの状態を取得
        // ONの場合、点呼割更新を行わない
        const checked = $('input#is_search_display').prop('checked');
        if(checked){
            return;
        }
        rollcall_refresh_approval_rate();
    });
}

/** --------------------------------------
 * 印刷用日次情報制御
 * 各functionで使用するためGlobal定義
 -------------------------------------- */

var dailyApproval = {
    /*---- 印刷用日次情報要素の親ID ----*/
    id: '#rollcall-detail-modal',

    /*---- 保存済み印刷用日次情報 ----*/
    result: '',

    /*---- 営業所選択判断 ----*/
    isPost: function() {
        return $('#rollcall-detail-modal select[name="section_id"]').val().length > 0
    },

    /*---- パラメタ編集 ----*/
    setParam: function(data = {}) {
        dailyApproval.data = {
            'section_id': $('#rollcall-detail-modal select[name="section_id"]').val(),
            'approval_date': $('#rollcall-detail-modal input[name="date"]').val(),
        }
        return Object.assign(dailyApproval.data, data);
    },

    /*---- 印刷用日次情報取得 ----*/
    postGet:function() {
        let action = $('#rollcall-daily-approval-block').data('action_get');
        let param = dailyApproval.setParam();
        // POST
        _ajax.post(action, param, function (results) {
            dailyApproval.setSelect(results);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    },

    /*---- 印刷用日次情報保存 ----*/
    postSave:function(data) {
        let action = $('#rollcall-daily-approval-block').data('action_save');
        let param = dailyApproval.setParam(data);
        // POST
        _ajax.post(action, param, function (results) {
            // 特に何もしない
            // 完了メッセージをセットする場合は、以下をイキにする
            // _complete.set(results);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    },

    /*---- 保存済み印刷用日次情報の選択済を制御 ----*/
    setSelect:function(results) {
        dailyApproval.result = results.result;
        // user用select2が生成済かどうかを監視
        let interval = setInterval(function () {
            if ($('#select2-print-form-print_general_id-container').length > 0
                && $('#select2-print-form-print_operator_id-container').length > 0
                && $('#select2-print-form-print_assistant_id-container').length > 0
                && $('#select2-print-form-weather-container').length > 0) {
                dailyApproval.clearEvent();
                // 印刷用日次情報が保存されている場合はselect2選択済みにする
                if (dailyApproval.result !== '') {
                    let relationNames = {
                        'print_general_id' : 'general_user',
                        'print_operator_id' : 'operator_user',
                        'print_assistant_id' : 'assistant_user',
                    }
                    // 削除済みのユーザーで、選択肢に存在しなければ追加する
                    $.each(['print_general_id', 'print_operator_id', 'print_assistant_id'], function (index, value) {
                        let element = $(dailyApproval.id + ' select[name="' + value + '"]');
                        // リレーション取得
                        let printUserId = dailyApproval.result[value];
                        // オプションにユーザーIDが存在するか
                        if (element.find("option[value='" + printUserId + "']").length === 0) {
                            // リレーション取得
                            let relationName = relationNames[value];
                            let deletedUserInfo = dailyApproval.result[relationName];
                            if (!deletedUserInfo) {
                                return;
                            }
                            let newOption = new Option(deletedUserInfo.user_name, deletedUserInfo.id, true, true);
                            // 選択肢追加
                            element.append(newOption).trigger('change');
                        }
                    });
                    $(dailyApproval.id + ' #print-form-is_normal_alcohol_detector_' + dailyApproval.result.is_normal_alcohol_detector).prop('checked', true)
                        .parent('label').addClass('active');
                    $(dailyApproval.id + ' select[name="print_general_id"]').val(dailyApproval.result.print_general_id).trigger('change');
                    $(dailyApproval.id + ' select[name="print_operator_id"]').val(dailyApproval.result.print_operator_id).trigger('change');
                    $(dailyApproval.id + ' select[name="print_assistant_id"]').val(dailyApproval.result.print_assistant_id).trigger('change');
                    $(dailyApproval.id + ' select[name="weather"]').val(dailyApproval.result.weather).trigger('change');
                }
                dailyApproval.setEvent();
                clearInterval(interval);
            }
        }, 100);
    },

    /*---- イベントクリア ----*/
    clearEvent:function() {
        // アルコール検知器状況変更時
        $(dailyApproval.id + ' input[name="is_normal_alcohol_detector"]').off("change");
        // 統括運行管理者
        $(dailyApproval.id + ' select[name="print_general_id"]').off("select2:select");
        // 運行管理者
        $(dailyApproval.id + ' select[name="print_operator_id"]').off("select2:select");
        // 補助者
        $(dailyApproval.id + ' select[name="print_assistant_id"]').off("select2:select");
        // 天候
        $(dailyApproval.id + ' select[name="weather"]').off("select2:select");
    },

    /*---- イベント登録 ----*/
    setEvent:function() {
        // アルコール検知器状況変更時
        $(dailyApproval.id + ' input[name="is_normal_alcohol_detector"]').on('change', function() {
            if (!dailyApproval.isPost()) return;
            // 印刷用日次情報保存
            if ($(this).parent().hasClass('active')) {
                dailyApproval.postSave({'is_normal_alcohol_detector': $(this).val()});
            } else {
                dailyApproval.postSave({'is_normal_alcohol_detector': null});
            }
        });
        // 統括運行管理者
        $(dailyApproval.id + ' select[name="print_general_id"]').on('select2:select', function() {
            if (!dailyApproval.isPost() || $(this).val() === dailyApproval.result.print_general_id) return;
            // 印刷用日次情報保存
            dailyApproval.postSave({'print_general_id': $(this).val()});
        });
        // 運行管理者
        $(dailyApproval.id + ' select[name="print_operator_id"]').on('select2:select', function() {
            if (!dailyApproval.isPost() || $(this).val() === dailyApproval.result.print_operator_id) return;
            // 印刷用日次情報保存
            dailyApproval.postSave({'print_operator_id': $(this).val()});
        });
        // 補助者
        $(dailyApproval.id + ' select[name="print_assistant_id"]').on('select2:select', function() {
            if (!dailyApproval.isPost() || $(this).val() === dailyApproval.result.print_assistant_id) return;
            // 印刷用日次情報保存
            dailyApproval.postSave({'print_assistant_id': $(this).val()});
        });
        // 天候
        $(dailyApproval.id + ' select[name="weather"]').on('select2:select', function() {
            if (!dailyApproval.isPost() || $(this).val() === dailyApproval.result.weather) return;
            // 印刷用日次情報保存
            dailyApproval.postSave({'weather': $(this).val()});
        });
    }
}

window.rollcall_refresh_approval_rate = function() {

    var elm = $('.monthly-rate');
    if (elm.length === 0) {
        return;
    }
    // アクションの取得
    let action = extend_url_query($(elm).data('action'));
    // 検索フォームを配列化
    let datas = $('#search-form').serializeArray();
    _ajax.background(action, datas, function (results) {
        $('.monthly-rate').html(results);
    }, function(xhr, status, errorThrown) {
        _error.omitted(xhr, status, errorThrown);
    }, 'html');
}

/**
 * ページ読み込み時のイベント設定
 */
window.rollcall_event_set = function () {

    // 点呼予定タブ 一括処理ボタンをdisabledにする
    setDisabledBulkButton(true);

    // search.jsのイベントが先に実行されるため、一旦offにして再設定
    $(document).off('change', '#search-form, #toolbar-keyword-search');
    // 検索フォームの変更時
    // ※カレンダー切り替え、タブ切り替え以外は「検索ボタンを表示する」トグルボタンがOFFのときのみ処理する
    $(document).on('change', '#search-form', function(e) {
        // 変更によってロードしないdata属性がある場合
        if (e.target.getAttribute('data-no-load-self-change')) {
            return;
        }
        // タブタイプ
        let pageType = $('#search-form-type').val();
        // 「検索ボタンを表示する」ON／OFF
        let isSearchToggl = $('#is_search_display').prop('checked');
        // トグル切り替え時は自動検索しない
        if($(e.target).is('input#is_search_display')){
            return;
        }
        // トグルがONの時、自動検索をキャンセルする　ただし、カレンダー切り替え、タブ切り替えの時はキャンセルしない
        if(isSearchToggl && !$(e.target).is('input.month-picker-value') && !$(e.target).is('input#search-form-type')){
            return;
        }
        // エラー表示を初期化
        _error.reset();
        // 点呼割が存在するカレンダータブの場合、コンテンツを読込
        load_contents(function () {
            // 点呼割更新
            if (pageType !== 'expectation_list') {
                // 「検索ボタンを表示する」トグルの状態を取得
                // ONの場合、点呼割更新を行わない
                const checked = $('input#is_search_display').prop('checked');
                if(checked){
                    return;
                }
                rollcall_refresh_approval_rate();
            } else {
                // 一括処理ボタンをdisabledにする
                setDisabledBulkButton(true);
            }
        }, false);
    });

    /*---- 「検索ボタンを表示する」トグルボタン切り替え時 ----*/

    // 「検索ボタンを表示する」トグルボタン切り替え時
    // API呼び出し、検索ボタンの表示／非表示 切り替え
    $(document).on('change', '#is_search_display', function() {
        let searchButton = $('#form-action_search');
        const checked = $(this).prop('checked');
        const action = $(this).data('user_setting_save_action');
        const key = $(this).data('user_setting_key');
        // 「検索ボタンを表示する」トグルがONのとき、自動検索はOFFになるため、checkedと逆になる
        const value = checked ? 1 : 2;
        const params = {'setting_key': key, 'setting_value' : value};
        // 表示保持用API(user_setting)
        _ajax.post(action, params, function (results) {
            // 「検索ボタンを表示する」トグルがOFFになるときは、表示保持を行った後に自動検索する
            if(!checked){
                // タブタイプ
                let pageType = $('#search-form-type').val();
                // 点呼割が存在するカレンダータブの場合、コンテンツを読込
                load_contents(function () {
                    // 点呼割更新
                    if (pageType !== 'expectation_list') {
                        rollcall_refresh_approval_rate();
                    } else {
                        // 一括処理ボタンをdisabledにする
                        setDisabledBulkButton(true);
                    }
                }, false);
            }
        }, function (xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
        // チェックの有無に合わせて検索ボタンの表示／非表示切り替え
        if(checked){
            searchButton.removeClass('display-none');
        } else {
            searchButton.addClass('display-none');
        }
    });

    /*---- 検索ボタン押下時 ----*/

    // 検索ボタン押下時
    $(document).on('click', '#form-action_search', function (e) {
        // 変更によってロードしないdata属性がある場合
        if (e.target.getAttribute('data-no-load-self-change')) {
            return;
        }
        // タブタイプ
        let pageType = $('#search-form-type').val();
        // エラー表示を初期化
        _error.reset();
        // hidden属性で検索ボタン押下時に値を持たせる
        $('#search-form').find('input[name="search_button"]').val('search');
        // 点呼割が存在するカレンダータブの場合、コンテンツを読込
        load_contents(function () {
            // 点呼割更新
            if (pageType !== 'expectation_list') {
                // 検索ボタン押下時に設定するhiddenはURLにセットしない（URLを上書き置換する）
                selector = '#search-form';
                const url = new URL(location.href);
                // 検索ボタン押下時のhiddenはパラメータから削除する
                url.searchParams.delete('search_button');
                // URLだけを置換
                history.replaceState(null, '', url.toString());

                rollcall_refresh_approval_rate();
            } else {
                // 一括処理ボタンをdisabledにする
                setDisabledBulkButton(true);
            }
        }, false);
    });

    /*---- ページタブ切り替え時 ----*/

    // タブ切り替え時
    $(document).on('click', '[data-page-type]', function() {
        let pageType = $(this).data('page-type');
        $('#search-form-type').val(pageType);
        $('#search-form-type').trigger('change');
        // 一括処理ボタンをdisabledにする
        setDisabledBulkButton(true);
    });

    /*---- 点呼詳細表示時 ----*/

    // 点呼詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['date'], true, function () {
            if ($('#rollcall-detail-modal-section_id').val().length > 0) {
                // 印刷用日次情報取得
                dailyApproval.postGet();
            }
        });
    });

    /*---- アルコール測定画像表示時 ----*/

    // アルコール測定画像表示時
    $(document).on('click', '[data-rollcall-alc-image-modal]', function () {
        _modal.create(this, 'rollcall-alc-image-modal', ['id']);
    });

    /*---- 記録ファイル表示時 ----*/

    // 記録ファイル表示時
    $(document).on('click', '[data-record-modal]', function (e) {
        e.stopPropagation();
        _modal.create(this, 'record-modal', ['id']);
    });

    /*---- 記録ファイル表示終了時 ----*/

    // 記録ファイル表示終了時
    $(document).on('hidden.bs.modal', '#rollcall-record-modal', function() {
        $('#rollcall-record-file').get(0).pause();
        $('#rollcall-record-file').get(0).currentTime = 0;
    });

    /*---- 記録ファイルダウンロード時 ----*/

    // 記録ファイル表示時
    $(document).on('click', '[data-download-modal]', function (e) {
        const action = $(this).data('download');
        location.href = action;
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function (e) {
        if ($(e.target).hasClass('file-download')) {
            return;
        }
        var modalId = create_id($(this).data('setting-modal'));

        // サーバー側に渡すデータキー
        let keys = ['id', 'user_id', 'holding_id', 'company_id', 'section_id', 'implement_section_id', 'vehicle_id', 'relation_id', 'date', 'type'];

        if (modalId === '#rollcall-print-select-modal') {
            // 個別印刷設定モーダル
            let searchForm = $('#search-form');
            let datas = [];
            // 印刷用の項目を追加（統括運行管理者・運行管理者・補助者・天候）
            $.each(['total_print_general_id', 'total_print_operator_id', 'total_print_assistant_id', 'weather'], function(i, key) {
                if (searchForm.find('[name=' + key + ']') != null) {
                    datas.push({'name' : key, 'value' : searchForm.find('[name=' + key + ']').val()});
                }
            });
            // キー追加
            $.each(keys, function(i, key) {
                if ($(this).data(key) != null) {
                    datas.push({'name' : key, 'value' : $(this).data(key)});
                }
            });
            _modal.create_with_data(this, 'setting-modal', datas, true, function() {
                $(modalId + ' select.driver-select').trigger('change');
            });
        } else {
            _modal.create(this, 'setting-modal', keys, true, function () {

                $(modalId + ' select.driver-select').trigger('change');

                // 選択会社変更時には実施営業所の表示/非表示を判定
                $(document).on('change', 'select.company-select', function() {
                    if ($(this).val() !== '') {
                        const datas = {'company_id': $(this).val()};
                        const action = $(this).data('action_is_implement_section_displayed');
                        if (action) {
                            _ajax.post(action, datas, function (results) {
                                $('#implement-place-form-group').toggleClass('d-none', (results.result != true));
                            })
                        }
                    }
                });

                // datalistによる書き換えが行われないため回避措置
                $(document).on('change', '#rollcall-setting-modal #rollcall-setting-modal-planned_location', function() {
                    $('#rollcall-setting-modal input[name=planned_location]').val($(this).val());
                });

                function set_expectation_form()
                {
                    let is_expectation = false;
                    if ($('input[name=is_expectation]').length) {
                        is_expectation = $('input[name=is_expectation]:checked').val() == 1;
                    }
                    if (is_expectation) {
                        $('#rollcall-setting-modal-planned_location').removeAttr('disabled');
                        $('#rollcall-setting-modal-location').attr('disabled', 'disabled');
                        $('#rollcall-setting-modal-location_additional').attr('disabled', 'disabled');
                    } else {
                        $('#rollcall-setting-modal-planned_location').attr('disabled', 'disabled');
                        if (!$('#rollcall-setting-modal-is_disabled').val()) {
                            $('#rollcall-setting-modal-location').removeAttr('disabled');
                        }
                        if (!$('#rollcall-setting-modal-is_locked').val()) {
                            $('#rollcall-setting-modal-location_additional').removeAttr('disabled');
                        }
                    }
                }
                //  予定/実績フラグ変更時
                $(document).on('change', '#rollcall-setting-modal input[name=is_expectation]', function() {
                    set_expectation_form();
                });
                set_expectation_form();

                // 実施場所区分変更時
                $(document).on('change', '#rollcall-setting-modal-form input[name=place_type]', function () {
                    const showImplementSectionSelect = $(this).data('section-type') == $(this).val();
                    const point = $('#rollcall-setting-modal-form #rollcall-setting-modal-point').val();
                    $('#rollcall-setting-modal-form #implement-section-form-group').toggleClass('d-none', !showImplementSectionSelect);
                    $('#rollcall-setting-modal-form #place-location').toggleClass('d-none', showImplementSectionSelect);
                    $('#rollcall-setting-modal-form #place-map').toggleClass('d-none', (!showImplementSectionSelect && point.length > 0));
                    set_expectation_form();
                });

            }, 'action', function (xhr) {
                if (xhr.status == 400) {
                    let showUnaccessibleModal = false;
                    const res = JSON.parse(xhr.responseText);
                    $.each(res.errors, function (i, message) {
                        if (message == '編集を行うための権限がありません。') {
                            showUnaccessibleModal = true;
                        }
                    });
                    if (showUnaccessibleModal) {
                        $('#rollcall-unaccessible-modal').modal('show');
                    } else {
                        _error.omitted(xhr);
                    }
                } else {
                    _error.omitted(xhr);
                }
            });
        }
    });

    /*---- 設定時 ----*/

    // 点呼設定時
    $(document).on('click', '[data-save-modal]', function () {
        let disableds = null;
        // 予定点呼の手動登録の場合は送信時にdisabledを解除
        if ($('input[name="is_manual"]').length > 0) {
            if ($(this).data('save-modal') == '#rollcall-setting-modal') {
                disableds = $('#rollcall-setting-modal').find('input:not([type=hidden]):disabled,select:disabled,textarea:disabled');
                disableds.each(function(i, e) {
                    $(e).prop('disabled', false);
                });
            }
        }
        $('#rollcall-setting-modal').find('input[name="only_validation"]').prop('disabled', true);
        window.modalScrollPositions['rollcall-detail-modal'] = {
            position: $('#rollcall-detail-modal').find('.modal-body').scrollTop(),
            timestamp: Date.now()
        };
        console.log(`スクロール位置を記録: ${window.modalScrollPositions['rollcall-detail-modal'].position}`);

        _modal.submit(this, 'save-modal', function(results) {
            $('[data-detail-modal=rollcall-detail-modal][data-date=' + moment(results.date).format("YYYY-MM-DD") + ']').trigger('click');
            rollcall_refresh_approval_rate();
        }, function() {
            // 送信結果がエラーだった場合、送信時に解除したdisabledを再設定
            if ($('input[name="is_manual"]').length > 0 && disableds != null) {
                disableds.each(function(i, e) {
                    $(e).prop('disabled', true);
                });
            }
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id'], false, null, 'action', function (xhr) {
                if (xhr.status == 400) {
                    $('#rollcall-unaccessible-modal').modal('show');
                }
            });
    });

    /*---- 削除時 ----*/

    // 削除時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            _modal.hide('#rollcall-setting-modal');
            $('[data-detail-modal=rollcall-detail-modal][data-date=' + moment(results.date).format("YYYY-MM-DD") + ']').trigger('click');
            rollcall_refresh_approval_rate();
        });
    });


    /*---- 承認 or 取消（点呼予定タブ） ----*/

    // 点呼予定一覧 一括承認チェック
    $(document).on('change', '#expectation_list input[name="rollcall_id_all"]', function () {
        let inputs = $('#expectation_list input[name="rollcall_ids[]"]');
        if ($(this).prop('checked')) {
            inputs.prop('checked', true).trigger('change');
        } else {
            inputs.prop('checked', false).trigger('change');
        }
    });

    // 点呼予定一覧「一括承認」「一括取消」アクティブ
    $(document).on('change', '#expectation_list input[name="rollcall_ids[]"]', function () {
        let checked = $('#expectation_list input[name="rollcall_ids[]"]:checked');
        if (checked.length > 0) {
            setDisabledBulkButton(false);
        } else {
            setDisabledBulkButton(true);
        }
    });

    /*---- 一括削除（点呼予定タブ） ----*/

    // 点呼予定一覧 一括削除チェック
    $(document).on('change', '#expectation_list input[name="delete_id_all"]', function () {
        let inputs = $('#expectation_list input[name="delete_ids[]"]');
        if ($(this).prop('checked')) {
            inputs.prop('checked', true).trigger('change');
        } else {
            inputs.prop('checked', false).trigger('change');
        }
    });

    // 点呼予定一覧「一括削除」アクティブ
    $(document).on('change', '#expectation_list input[name="delete_ids[]"]', function () {
        let checked = $('#expectation_list input[name="delete_ids[]"]:checked');
        $('#rollcall_expectation_list_bulk_delete').prop('disabled', checked.length == 0);
    });

    /*---- 点呼予定「一括削除」押下時 ----*/

    // 点呼予定「一括削除」押下時
    $(document).on('click', '#expectation_list [data-expectation-delete-confirm-modal]', function () {
        var ids =  [];
        $('#expectation_list input[name="delete_ids[]"]:checked').map(function() {
            ids.push($(this).val());
        });
        if (ids.length > 0) {
            _modal.create_with_data(this, 'expectation-delete-confirm-modal', {'ids': ids, 'holding_id' : $(this).data('holding_id')});
        }
    });

    /*---- 点呼予定削除時 ----*/

    // 点呼予定削除時
    $(document).on('click', '[data-expectation-delete-modal]', function () {
        _modal.submit(this, 'expectation-delete-modal', function() {
            _modal.hide('#rollcall-expectation-delete-modal');
            setDisabledBulkButton(true);
        });
    });

    /*---- 運行指示書変更確認時 ----*/

    // 変更確認時
    $(document).on('click', '[data-change_confirm-modal]', function () {
        _modal.create(this, 'change_confirm-modal', ['holding_id', 'company_id', 'relation_id']);
    });

    /*---- 運行指示書作成変更時 ----*/

    // 作成変更時
    $(document).on('click', '[data-change-modal]', function () {
        _modal.submit(this, 'change-modal', function(results) {
            $('[data-detail-modal=rollcall-detail-modal][data-date=' + moment(results.rollcall.rollcalled_at).format("YYYY-MM-DD") + ']').trigger('click');
            rollcall_refresh_approval_rate();
        });
    });

    /*---- 点呼簿設定 ----*/

    // 点呼簿設定表示時
    $(document).on('click', '[data-config-modal]', function () {
        _modal.create(this, 'config-modal', ['id', 'company_id'], true);
    });

    // 点呼簿設定保存時
    $(document).on('click', '[data-config-save-modal]', function () {
        _modal.submit(this, 'config-save-modal', function () {
            rollcall_refresh_approval_rate();
        });
    });

    // 乗務判断 "設定" 一覧表示時
    $(document).on('click', '[data-drive_judgement_setting_list-modal]', function () {
        _modal.create(this, 'drive_judgement_setting_list-modal', ['id', 'company_id', 'section_id']);
    });

    // 乗務判断 "設定" 一覧画面内の会社 or 営業所変更時
    $(document).on('select2:selecting', ' #rollcall-drive_judgement_setting-company_id:enabled, #rollcall-drive_judgement_setting-section_id', function(e) {
        $(this).val(e.params.args.data.id);
        if ($(this).attr('id') == 'rollcall-drive_judgement_setting-company_id') {
            $('#rollcall-drive_judgement_setting-section_id').val('');
        }
        let form = $(this).parents('form');
        _modal.update(form.data('modal_id'), form.attr('action'), form.serializeArray());
    });

    // 乗務判断 "設定" 表示時
    $(document).on('click', '[data-drive_judgement_setting_setting-modal]', function () {
        _modal.create(this, 'drive_judgement_setting_setting-modal', ['id', 'user_id', 'section_id', 'company_id']);
    });

    // 乗務判断 "設定" 削除確認時
    $(document).on('click', '[data-drive_judgement_setting_confirm-modal]', function () {
        _modal.create(this, 'drive_judgement_setting_confirm-modal', ['id']);
    });

    // 乗務判断 "設定" 削除時
    $(document).on('click', '[data-drive_judgement_setting_delete-modal]', function () {
        _modal.submit(this, 'drive_judgement_setting_delete-modal', null, null, '-form', true, function () {
            const form = $('#rollcall-drive_judgement_setting-form');
            _modal.update(form.data('modal_id'), form.attr('action'), form.serializeArray());
            rollcall_refresh_approval_rate();
        });
    });

    // 乗務判断 "設定" 保存時
    $(document).on('click', '[data-drive_judgement_setting_save]', function () {
        _modal.submit(this, 'drive_judgement_setting_save', null, null, '-form', true, function () {
            const form = $('#rollcall-drive_judgement_setting-form');
            _modal.update(form.data('modal_id'), form.attr('action'), form.serializeArray());
            rollcall_refresh_approval_rate();
        });
    });

    // 乗務判断 "初期設定" 表示時
    $(document).on('click', '[data-drive_judgement_setting_default-modal]', function () {
        _modal.create(this, 'drive_judgement_setting_default-modal', ['id', 'company_id']);
    });

    // 乗務判断 "初期設定" 保存時
    $(document).on('click', '[data-drive_judgement_setting_default_save]', function () {
        _modal.submit(this, 'drive_judgement_setting_default_save', null, null, '-form', true, function () {
            const form = $('#rollcall-drive_judgement_setting-form');
            _modal.update(form.data('modal_id'), form.attr('action'), form.serializeArray());
            rollcall_refresh_approval_rate();
        });
    });

    /*---- CSVダウンロード時 ----*/

    // カレンダー、点呼予定一覧共通
    $(document).on('click', '.csv-download', function(){
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

    /*---- CSVアップロード表示時 ----*/

    // 点呼予定一覧CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        let modalId = $(this).data('target');
        $(modalId + '-csv-submit-message').empty().addClass('display-none');
        $(modalId + '-csv-error').empty().addClass('display-none');
        $(modalId + '-csv_file_name').val('');
        $(modalId + '-csv').val('');
    });

    /*---- CSVアップロード画面の選択肢変更時 ----*/

    // 点呼予定一覧CSVアップロード画面の選択肢変更時
    $(document).on('change', '#rollcall-expectation-csv-setting-modal-holding_id, #rollcall-expectation-csv-setting-modal-company_id, #rollcall-expectation-csv-setting-modal-section_id', function () {
        // 既にCSV選択後であれば初期化処理
        if (!$('[data-csv-save-modal]').prop('disabled')) {
            let modalId = '#rollcall-expectation-csv-setting-modal';
            $(modalId + '-csv-submit-message').empty().addClass('display-none');
            $(modalId + '-csv-error').empty().addClass('display-none');
            $(modalId + '-csv_file_name').val('');
            $(modalId + '-csv').val('');
            $(modalId + '-data_path').val('');
            $('[data-csv-save-modal]').prop('disabled', true);
            $(modalId + '-csv-dropzone .filename-preview').html('');
        }
    });

    /*---- CSVアップロード確認時 ----*/

    // 点呼予定一覧CSVアップロード確認時
    $(document).on('change', '#rollcall-expectation-csv-setting-modal-csv', function () {
        // $("[data-csv-save-modal]").prop("disabled", false);

        let modalId = '#rollcall-expectation-csv-setting-modal';
        let formId = '#rollcall-expectation-csv-setting-modal-form';
        let action = $(formId).data('confirm-action');
        let datas = new FormData($(formId).get(0));
        $(modalId + '-csv-error').addClass('display-none');
        $(modalId + '-csv-error').empty();
        $(modalId + '-csv-submit-message').addClass('display-none');
        $(modalId + '-csv-submit-message').empty();
        $("[data-csv-save-modal]").prop("disabled", true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(modalId + '-csv-submit-message').removeClass('display-none');
            $(modalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
            $(modalId + '-data_path').val(results.data_path);
            $(formId).attr('data-show_confirm_modal', results.isUncompletedJobExisting ? 'true' : 'false');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
            $(this).val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(modalId + '-csv-error').removeClass('display-none');
                $(modalId + '-csv-error').append($('<li></li>').text(message));
                $(modalId + '-csv_file_name').val('');
                $(modalId + '-csv').val('');
                $(modalId + '-data_path').val('');
                $(modalId + '-csv-dropzone .filename-preview').html('');
            });
        });
    });

    /*---- CSVアップロード時 ----*/

    // 点呼予定一覧CSVアップロード時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let modalId = '#rollcall-expectation-csv-setting-modal';
        let formId = '#rollcall-expectation-csv-setting-modal-form';
        let action = $(formId).attr('action');
        let datas = new FormData($(formId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 確認モーダルの表示が必要な場合
        if ($(formId).attr('data-show_confirm_modal') == 'true') {
            $(modalId).find('input[name="only_validation"]').prop('disabled', false);
            datas = new FormData($(formId).get(0));
            _ajax.file(action, datas, function (results) {
                _modal.show('#rollcall_expectation_csv_confirm-modal');
                $(modalId).find('input[name="only_validation"]').prop('disabled', true);
            datas = new FormData($(formId).get(0));
            }, function(xhr, status, errorThrown){
                // エラーをセットする
                _error.omitted(xhr, status, errorThrown);
                $(modalId).find('input[name="only_validation"]').prop('disabled', true);
            });
        // 確認モーダルの表示が不要な場合
        } else {
            // 送信
            _ajax.file(action, datas, function (results) {
                // 完了メッセージをセットする
                _complete.set(results);
                // モーダルを閉じる
                _modal.hide(modalId);
                // コンテンツの読込
                load_contents(function () {
                    setDisabledBulkButton(true);
                });
            }, function(xhr, status, errorThrown){
                // エラーをセットする
                _error.omitted(xhr, status, errorThrown);
                $(modalId).find('input[name="only_validation"]').prop('disabled', true);
            });
        }
    });

    /*---- CSV確認メッセージモーダルの「確認」押下時----*/

    $(document).on('click', '[data-expectation-csv-confirm-modal]', function () {
        _modal.hide('#rollcall_expectation_csv_confirm-modal');
        $('#rollcall-expectation-csv-setting-modal-form').attr('data-show_confirm_modal', 'false');
        // CSVファイルによる点呼予定設定モーダルのアップロードボタンをクリックする
        $('[data-csv-save-modal]').trigger('click');
    });

    // CSV取込状況表示時
    $(document).on('click', '[data-rollcall-expectation-csv-list-modal]', function () {
        _modal.create(this, 'rollcall-expectation-csv-list-modal', ['holding_id', 'company_id', 'section_id']);
    });

    // CSV取込状況詳細表示時
    $(document).on('click', '[data-rollcall-expectation-csv-list-detail-modal]', function () {
        _modal.create(this, 'rollcall-expectation-csv-list-detail-modal', ['rollcall_import_job_id', 'holding_id']);
    });

    // CSV取込の取消確認画面表示
    $(document).on('click', '[data-rollcall-expectation-csv-cancel-confirm-modal]', function () {
        _modal.create(this, 'rollcall-expectation-csv-cancel-confirm-modal', ['rollcall_import_job_id', 'holding_id']);
    });

    // CSV取込の取消
    $(document).on('click', '[data-rollcall-expectation-csv-cancel-modal]', function () {
        _modal.submit(this, 'rollcall-expectation-csv-cancel-modal', function() {
            _modal.hide('#rollcall-expectation-csv-cancel-confirm-modal');
            _modal.hide('#rollcall-expectation-csv-list-modal');
            $('[data-rollcall-expectation-csv-list-modal]').trigger('click');
        }, null, '-form', true);
    });

    /*---- 選択印刷表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-print-select-modal]', function (e) {
        if ($(e.target).hasClass('file-download')) {
            return;
        }
        var modalId = create_id($(this).data('setting-modal'));
        _modal.create(this, 'setting-modal', ['id', 'user_id', 'holding_id', 'company_id', 'section_id', 'vehicle_id', 'relation_id', 'date', 'type'], true, function() {
            $(modalId + ' select.driver-select').trigger('change');
        });
    });

    // 選択印刷
    $(document).on('click', '[data-select-print-modal]', function () {
        let modalId = create_id($(this).data('select-print-modal'));
        let form = $(modalId).find('form');
        let formId = '#' + form.attr('id');
        // 送信値を配列化
        let datas = form.serializeArray();
        let action = extend_url_query(form.attr('action'));
        // 送信前にエラーをリセット
        _error.reset()
        _ajax.confirm_submit(formId, action, function (result) {
            // エラー無ければBlobでPDFを別ウィンドウで表示（エラーメッセージを受け取れるver）
            let new_datas = datas.filter((item) => item.name !== 'print_select_display');
            _ajax.blob_with_error(action, new_datas, function (blob) {
                window.open(window.URL.createObjectURL(blob), '_blank');
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown);
        });
    });

    // 日別モーダルの表示設定や、印刷・Excel時の「社員でまとめる」の表示／非表示制御
    $(document).on('change', '.display_order_block select[name="order"]', function() {
        const val = $(this).val();
        const $form = $(this).closest('form');
        const $target = $form.find('.group_by_user_flag_block');
        if (val === 'user_code' || val === 'user_kana') {
          $target.addClass('d-none');
        } else {
          $target.removeClass('d-none');
        }
    });

}

/**
 * 詳細モーダル表示時のイベント設定
 * @uses ダッシュボードからモーダル表示する際にも呼び出される
 */
window.rollcall_detail_event_set = function () {

    /*---- 点呼詳細検索時 ----*/

    const detail_list_update = function(elm)
    {
        let form = $(elm).parents('form');
        let dates = $(form).serializeArray();
        let action = $(form).attr('action');
        let modalId = $(form).data('modal_id');
        var _this = $(elm);
        _modal.update(modalId, action, dates, true, function(){
            if (_this.attr('id') == 'rollcall-detail-modal-section_id') {
                if (_this.val().length === 0) return;
                // 印刷用日次情報取得
                dailyApproval.postGet();
            }
        });
    }

    // 点呼詳細検索時
    $(document).on('change', '#rollcall-detail-modal-implement_section_search', function(e) {
        detail_list_update(this);
    });

    /*---- 日別一覧モーダル内の「ヘッダーを固定する」クリック時 ----*/
    $(document).on('change', '#rollcall-detail-modal-rollcall_header_position', function() {
        const action = $(this).data('user_setting_save_action');
        const key = $(this).data('user_setting_key');
        // valueが 2 なら固定する（追従する）
        const value = $(this).prop('checked') ? 2 : 1;
        const params = {'setting_key': key, 'setting_value' : value};
        // 表示保持用API(user_setting)
        _ajax.post(action, params, function (results) {
        }, function (xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
        // チェックの有無に合わせて執行者一覧取得
        if ($(this).prop('checked')) {
            $('#rollcall-detail-modal .rollcall-day-table .header-top').toggleClass('sticky-top-zindex1', true);
        } else {
            $('#rollcall-detail-modal .rollcall-day-table .header-top').toggleClass('sticky-top-zindex1', false);
        }
    });

    // 点呼詳細検索時
    $(document).on('select2:selecting', '#rollcall-detail-modal-holding_id:enabled, #rollcall-detail-modal-company_id:enabled, #rollcall-detail-modal-section_id', function(e) {
        console.log("call?");
        $(this).val(e.params.args.data.id);
        if ($(this).attr('id') == 'rollcall-detail-modal-holding_id') {
            $('#rollcall-detail-modal-company_id').val('');
            $('#rollcall-detail-modal-section_id').val('');
        }
        if ($(this).attr('id') == 'rollcall-detail-modal-company_id') {
            $('#rollcall-detail-modal-section_id').val('');
        }
        detail_list_update(this);
    });

    // 点呼設定画面 営業所変更時 点呼区分表示切替
    $(document).on('select2:select', '#rollcall-setting-modal-section_id:enabled', function(e) {
        // 営業所の設定によって、点呼区分「中間」の表示を切り替える
        switchMiddleDisplay(true);
    });

    // 営業所の設定によって、点呼区分「中間」の表示を切り替える
    function switchMiddleDisplay(isChangeBySection = false) {
        let rollcallTypes = $('#rollcall-setting-modal').find('[name="rollcall_type"]');
        let middleInput = $('#rollcall-setting-modal').find('input[name="rollcall_type"][value="2"]');
        let middleLabel = middleInput.parent('label');
        let section = $('#rollcall-setting-modal-section_id').val();
        // 初期表示・営業所が変わったタイミングで取得（configの権限が無い場合は、actionの設定なし）
        let action = rollcallTypes.first().data('action');
        let defaultShow = rollcallTypes.first().data('middle-default');

        // 初期表示の場合は時間短縮の為、ajaxを実行させない
        if (!isChangeBySection) {
            if (typeof defaultShow !== 'undefined' && !defaultShow) {
                middleLabel.addClass('display-none');
            } else {
                middleLabel.removeClass('display-none');
            }
            return;
        }
        // 権限が無ければ初期設定のみ行い終了
        if (typeof action === 'undefined') {
            return;
        }
        // 営業所の指定が無ければ初期化（中間を表示）
        if (!section) {
            middleLabel.removeClass('display-none');
            return;
        }
        // 送信
        _ajax.post(action, [
            {'name': 'expect_json', 'value': true},
            {'name': 'section_id', 'value': section},
        ], function (results) {
            results = JSON.parse(results)
            let config = results.rollcall_config;
            if (config && config.hasOwnProperty('is_middle_rollcall') && !config.is_middle_rollcall) {
                // 選択を解除
                if (middleInput.is(':checked')) {
                    middleInput.prop('checked', false);
                }
                // 中間を非表示
                middleLabel.addClass('display-none').removeClass('active');
            } else {
                middleLabel.removeClass('display-none');
            }
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }

    /*---- 点呼登録モーダルの「承認」----*/

    $(document).on('click', '[data-expectation-authorize-modal]', function () {
        let disableds = null;
        // 送信時にdisabledを解除
        disableds = $('#rollcall-setting-modal').find('input:not([type=hidden]):disabled,select:disabled,textarea:disabled');
        disableds.each(function(i, e) {
            $(e).prop('disabled', false);
        });
        $('#rollcall-setting-modal').find('input[name="only_validation"]').prop('disabled', false);
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.submit('#rollcall-setting-modal-form', function (results) {
            // 承認用確認モーダル表示
            _modal.show('#rollcall_expectation_authorize-modal');
            $('#rollcall-setting-modal').find('input[name="only_validation"]').prop('disabled', true);
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set('#rollcall-setting-modal', xhr, status, errorThrown);
            // 送信結果がエラーだった場合、送信時に解除したdisabledを再設定
            if (disableds != null) {
                disableds.each(function(i, e) {
                    $(e).prop('disabled', true);
                });
            }
            $('#rollcall-setting-modal').find('input[name="only_validation"]').prop('disabled', true);
        });
    });

    /*---- 点呼登録モーダル内での承認確認モーダルの「承認」押下時----*/

    $(document).on('click', '[data-expectation-authorize-save-modal]', function () {
        _modal.hide('#rollcall_expectation_authorize-modal');
        // 点呼登録モーダルの保存ボタンをクリックする
        $('[data-save-modal]').trigger('click');
    });

    /*---- 予定点呼一覧の「承認」 ----*/

    // 「承認」ボタン押下後、変更確認時
    $(document).on('click', '[data-expectation-confirm-modal]', function () {
        let data = {
            'is_expectation_authorized': $(this).data('is_expectation_authorized'),
        }
        if ($(this).data('bulk-action')) {
            // 一括チェック済み取得
            data.rollcall_ids = $('#expectation_list input[name="rollcall_ids[]"]:checked').map(function () {
                return $(this).val();
            }).get();
        } else {
            data.rollcall_id = $(this).data('rollcall_id');
        }
        _modal.create_with_data(this, 'expectation-confirm-modal', data);
    });

    // 点呼予定確認画面 保存押下
    $(document).on('click', '[data-expectation_save_modal]', function () {
        let settingModalId = '#rollcall-setting-modal';
        let pageType = $('#search-form-type').val() ?? 'calendar';
        _modal.submit(this, 'expectation_save_modal', function (data) {
            if (pageType === 'calendar') {
                let result = data.result;
                if (!result.hasOwnProperty('status') || !result.hasOwnProperty('rollcall') || !result.hasOwnProperty('is_bulk')) {
                    return;
                }
                $(create_id(settingModalId)).modal('hide');
                // 承認済みに合った表示にする為に、日毎モーダル状態に戻す
                if (result.status === 'authorized' && !result.is_bulk && result.rollcall.rollcalled_at) {
                    $('[data-detail-modal=rollcall-detail-modal][data-date=' + moment(result.date).format("YYYY-MM-DD") + ']').trigger('click');
                }
            } else {
                // 点呼予定タブ
                load_contents(function () {
                    setDisabledBulkButton(true);
                });
            }
        }, null, '-form', true);
    });

    /*---- 印刷ボタン押下時 ----*/

    // 印刷確認モーダル表示
    $(document).on('click', '[data-print]', function () {
        // 送信値を配列化
        let datas = $('#rollcall-detail-modal-form').serializeArray();
        let keys = [];
        let element = document.getElementById('rollcall_print_daily_download');
        $.each(datas, function(index, value) {
            element.dataset[value.name] = value.value;
            if(value.value != null && value.value != "")
                keys.push(value.name);
        });
        keys.push('date');
        // キャッシュクリア
        $(element).removeData();

        _modal.create(element, 'print-confirm-modal', keys, true, function() {
        }, 'print');
    });

    /*---- 一括印刷ボタン押下時 ----*/

    // 印刷時
    $(document).on('click', '[data-total-print]', function () {
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // 一括印刷のキー追加
        datas.push({ name: 'is-total', value: true });
        _modal.create_with_data(this, 'print-confirm-modal', datas, true, function() {
        }, 'total-print');
    });

    /*---- 印刷確認モーダルでの印刷ボタン押下時 ----*/

    // 印刷ボタン押下時
    $(document).on('click', 'button#print-go', function () {
        // 送信値を配列化
        let datas = $('#rollcall-print-confirm-modal-form').serializeArray();
        let action = extend_url_query($(this).data('action'));

        // BlobでPDFを別ウィンドウで表示（エラーメッセージを受け取れるver）
        _ajax.blob_with_error(action, datas, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- Excelの出力時 ----*/

    // 日別モーダルからのExcel出力確認モーダル表示時
    $(document).on('click', '[data-excel]', function () {
        // 送信値を配列化
        let datas = $('#rollcall-detail-modal-form').serializeArray();
        let keys = [];
        let element = document.getElementById('rollcall_excel_daily_download');
        $.each(datas, function(index, value) {
            element.dataset[value.name] = value.value;
            if(value.value != null && value.value != "")
                keys.push(value.name);
        });
        keys.push('date');
        // キャッシュクリア
        $(element).removeData();

        _modal.create(element, 'excel-confirm-modal', keys, true, function() {
        }, 'excel');
    });

    // カレンダー画面からのExcel出力確認モーダル表示時
    $(document).on('click', '[data-total-excel]', function () {
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // 一括印刷のキー追加
        datas.push({ name: 'is-total', value: true });
        _modal.create_with_data(this, 'excel-confirm-modal', datas, true, function() {
        }, 'total-excel');
    });

    // Excel出力確認モーダルの出力ボタン押下時
    $(document).on('click', 'button#excel-go', function () {
        // 送信値を配列化
        let datas = $('#rollcall-excel-confirm-modal-form').serializeArray();
        let action = extend_url_query($(this).data('action'));

        // BlobでExcelをダウンロード（エラーメッセージを受け取れるver）
        _ajax.blob_with_error(action, datas, function (blob) {
            // ファイル名はサーバー側で設定されるため、デフォルト値を使用
            const fileName = '点呼記録簿.xlsx';
            const downloadUrl = URL.createObjectURL(blob);
            const aTag = document.createElement('a');
            aTag.href = downloadUrl;
            aTag.download = fileName;
            document.body.appendChild(aTag);
            aTag.click();
            aTag.remove();
            URL.revokeObjectURL(downloadUrl);
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- 点呼タイプ変更時のフォーム表示 ----*/

    // 設定モーダル表示時に処理
    $(document).on('show.bs.modal', '#rollcall-setting-modal', function (e) {
        switchMiddleDisplay();
        rollcall_setting_set_by_rollcall_type($('.rollcall-setting-rollcall-type:checked'));
    });
    // トグルボタン押下時
    $(document).on('change', '.rollcall-setting-rollcall-type', function () {
        rollcall_setting_set_by_rollcall_type(this);
    });

    /*---- 日常点検詳細表示 ----*/

    // 日常点検選択ボタン押下時
    $(document).on('click', '#rollcall-setting-modal [data-daily_check-select-modal]', function (e) {
        let btnSelect = $(this);
        let btnUnSelect = $('#rollcall-setting-modal-daily_check-unselect');
        let btnDetail = $('#rollcall-setting-modal [data-daily_check-detail-modal]');
        let params = getDailyCheckParams();

        _modal.create_with_data(this, 'daily_check-select-modal', params, true, function() {
            daily_check_select_event_set(function(result){
                $('#rollcall-setting-modal-daily_check_id').val(result);
                $(btnSelect).addClass('display-none');
                $(btnUnSelect).removeClass('display-none');
                $(btnDetail).removeClass('display-none');
            });
        });
    });

    // 日常点検選択解除ボタン押下時
    $(document).on('click', '#rollcall-setting-modal-daily_check-unselect', function (e) {
        let btnSelect = $('#rollcall-setting-modal [data-daily_check-select-modal]');
        let btnUnSelect = $(this);
        let btnDetail = $('#rollcall-setting-modal [data-daily_check-detail-modal]');
        if (btnDetail.length == 0) {
            btnDetail = $('#rollcall-setting-modal [data-target="#daily_check-unaccessible-modal"]');
        }
        $('#rollcall-setting-modal-daily_check_id').val('');
        $(btnUnSelect).addClass('display-none');
        $(btnSelect).removeClass('display-none');
        $(btnDetail).addClass('display-none');
    });

    // 日常点検詳細ボタン押下時
    $(document).on('click', '#rollcall-setting-modal [data-daily_check-detail-modal]', function (e) {
        let params = getDailyCheckParams();
        _modal.create_with_data(this, 'daily_check-detail-modal', params, true);
    });

    function getDailyCheckParams()
    {
        return {
            'id' : $('#rollcall-setting-modal-daily_check_id').val(),
            'holding_id' : $('#rollcall-setting-modal-holding_id').val(),
            'company_id' : $('#rollcall-setting-modal-company_id').val(),
            'vehicle_id' : $('#rollcall-setting-modal-vehicle_id').val(),
            'date' : $('#rollcall-setting-modal-rollcalled_at').val(),
            'type' : 'result',
        };
    }

    // 日毎一覧 日常点検セル 押下時
    $(document).on('click', '.rollcall-day-table [data-daily_check-detail-modal]', function (e) {
        // バブリング停止
        e.stopPropagation();
        _modal.create(this, 'daily_check-detail-modal', ['id', 'company_id', 'vehicle_id'], true);
    });

    // アルコール検知器状況を選択後、未選択へも変更可にする
    $(document).on('click', dailyApproval.id + ' input[name="is_normal_alcohol_detector"]', function() {
        var label = $(this).parent();
        if (label.hasClass('active')) {
            setTimeout(() => {
                $(this).prop('checked', false);
                label.removeClass('active');
                $(this).trigger('change');
            }, 0);
        }
    });

    // 故障内容設定表示時
    $(document).on('click', '[data-malfunction-setting-modal]', function() {
        // 中止ボタンの場合、先に点呼登録モーダルのバリデーションチェックを行う
        if ($(this).data('is_cancel') != false) {
            let disableds = null;
            // 送信時にdisabledを解除
            disableds = $('#rollcall-setting-modal').find('input:not([type=hidden]):disabled,select:disabled,textarea:disabled');
            disableds.each(function(i, e) {
                $(e).prop('disabled', false);
            });
            const onlyValidation = $('#rollcall-setting-modal input[name="only_validation"]');
            onlyValidation.prop('disabled', false);
            // 送信前にエラーをリセット
            _error.reset()
            // バリデーションチェックのために送信する
            _ajax.submit('#rollcall-setting-modal-form', function (results) {
                onlyValidation.prop('disabled', true);
                // OKだった場合は、故障内容入力モーダルを表示
                _modal.create('#rollcall-setting-modal-cancel-btn', 'malfunction-setting-modal', ['id', 'is_cancel'], false, function() {
                    const types = $('#rollcall-setting-modal-malfunction_types').val().split(',');
                    const other = $('#rollcall-setting-modal-malfunction_other_content').val();
                    $('.rollcall-setting-malfunction-type').each(function(index, element) {
                        $(element).prop('checked', (types.indexOf($(element).val()) != -1));
                    });
                    $('#rollcall-malfunction-setting-modal-malfunction_other_content').val(other);
                    // $('#rollcall-malfunction-setting-modal-malfunction_other_content').attr('disabled', !$('#rollcall-malfunction-setting-modal-malfunction_type_99').prop('checked'));
                });
            }, function(xhr, status, errorThrown){
                // エラーをセットする
                _error.set('#rollcall-setting-modal', xhr, status, errorThrown);
                // 送信結果がエラーだった場合、送信時に解除したdisabledを再設定
                if (disableds != null) {
                    disableds.each(function(i, e) {
                        $(e).prop('disabled', true);
                });
                }
                onlyValidation.prop('disabled', true);
            });
        // 故障内容入力ボタンの場合
        } else {
            _modal.create(this, 'malfunction-setting-modal', ['id', 'is_cancel'], false, function() {
                const types = $('#rollcall-setting-modal-malfunction_types').val().split(',');
                const other = $('#rollcall-setting-modal-malfunction_other_content').val();
                $('.rollcall-setting-malfunction-type').each(function(index, element) {
                    $(element).prop('checked', (types.indexOf($(element).val()) != -1));
                });
                $('#rollcall-malfunction-setting-modal-malfunction_other_content').val(other);
                // $('#rollcall-malfunction-setting-modal-malfunction_other_content').attr('disabled', !$('#rollcall-malfunction-setting-modal-malfunction_type_99').prop('checked'));
            });
        }
    });

    // その他入力時
    $(document).on('change', '#rollcall-malfunction-setting-modal-malfunction_other_content', function() {
        $('#rollcall-malfunction-setting-modal-malfunction_type_99').prop('checked', ($(this).val().length > 0));
    });
    // // その他入力状態操作
    // $(document).on('change', '#rollcall-malfunction-setting-modal-malfunction_type_99', function() {
    //     $('#rollcall-malfunction-setting-modal-malfunction_other_content').attr('disabled', !$(this).prop('checked'));
    // });

    // 故障内容設定保存時
    $(document).on('click', '[data-malfunction-save-modal]', function() {
        let types = [];
        $('.rollcall-setting-malfunction-type').each(function(index, element) {
            $(element).is(':checked') && types.push($(element).val());
        });
        const other = $('#rollcall-malfunction-setting-modal-malfunction_other_content').val();
        $('#rollcall-setting-modal-malfunction_types').val(types.join(','));
        $('#rollcall-setting-modal-malfunction_other_content').val(other);
        _modal.submit(this, 'malfunction-save-modal', function() {
            if (!$('#rollcall-malfunction-setting-modal-id').val()) {
                // 点呼簿：新規登録の場合、故障内容モーダルを閉じる
                $(create_id($(this).data('malfunction-save-modal'))).modal('hide');
            }else{
                // 点呼簿：編集→中止の場合、故障内容と点呼登録モーダルを閉じる
                if($('#rollcall-malfunction-setting-modal-is_cancel').val()){
                    // 点呼中止の場合、中止処理実行後、そのまま点呼登録モーダルを閉じる
                    $(create_id($(this).data('malfunction-save-modal'))).modal('hide');
                    // 点呼登録モーダル側のis_cancelの値をtrueにする
                    $('#rollcall-setting-modal-is_cancel').val(true);
                    // 点呼登録モーダルの保存ボタンをクリックする
                    $('[data-save-modal]').trigger('click');
                }
            }
        }, function() {
            $(create_id($(this).data('malfunction-save-modal'))).modal('show');
        }, '-form', true);
    });

    // 点呼登録モーダル内の乗務判断 "詳細" ボタン押下時（点呼に紐づく乗務判断全て表示）
    $(document).on('click', '[data-drive_judgement_rollcall_list-modal]', function () {
        _modal.create(this, 'drive_judgement_rollcall_list-modal', ['rollcall_id']);
    });

    // 乗務判断リストモーダル内の乗務判断 "詳細" ボタン押下時（各乗務判断を表示）
    $(document).on('click', '[data-rollcall_drive_judgement-setting-modal]', function () {
        _modal.create(this, 'rollcall_drive_judgement-setting-modal', ['id', 'status']);
    });

    // 乗務判断 "詳細" 理由保存時
    $(document).on('click', '[data-rollcall_drive_judgement-save-modal]', function () {
        // 点呼簿、ダッシュボード、乗務判断で使用されるため、点呼に限る
        _modal.submit(this, 'rollcall_drive_judgement-save-modal', function () {
            $(create_id($(this).data('rollcall_drive_judgement-save-modal'))).modal('hide');
            let listTriggerButton = $('#rollcall-setting-modal-drive_judgement_result');
            let data = {'rollcall_id': listTriggerButton.data('rollcall_id'), 'drive_judgement_id': listTriggerButton.data('drive_judgement_id')};
            _modal.update(listTriggerButton.data('drive_judgement_rollcall_list-modal'), listTriggerButton.data('action'), data);
        }, function () {
            $(create_id($(this).data('rollcall_drive_judgement-save-modal'))).modal('show');
        }, '-form', true);
    });

    /*---- 表示設定 ----*/

    // 表示設定の適用時
    $(document).on('click', '[data-rollcall-display-save-modal]', function() {
        const date = $('#rollcall-detail-modal-date').val();
        _modal.submit(this, 'rollcall-display-save-modal', function() {
            $('.calendar [data-date=' + date + ']').trigger('click');
        });
    });

    // 表示設定の初期化時
    $(document).on('click', '[data-rollcall-display-delete-modal]', function() {
        const date = $('#rollcall-detail-modal-date').val();
        _modal.submit(this, 'rollcall-display-delete-modal', function() {
            $('.calendar [data-date=' + date + ']').trigger('click');
        });
    });

    /*---- 点呼登録モーダル画面 カスタマイズ項目 ----*/

    rollcall_setting_form_customize_option_set('rollcall-setting-modal');
}

// 予定点呼一括承認ボタン状態の変更
window.setDisabledBulkButton = function(disabled = true) {
    let btnAuthorized = $('#rollcall_expectation_list_bulk_authorized');
    let btnCancel = $('#rollcall_expectation_list_bulk_cancel');
    if (btnAuthorized.length === 0 || btnCancel.length === 0) {
        return;
    }
    btnAuthorized.prop('disabled', disabled);
    btnCancel.prop('disabled', disabled);
}

window.rollcall_setting_set_by_rollcall_type = function (selector) {
    let type = $(selector).val();
    let settingModalId = create_id($(selector).data('modal-id'));
    let formId = create_id($(selector).data('form-id'));
    let isExpectation = $('input[name="is_expectation"]').length && $('input[name="is_expectation"]:checked').val() == 1 ? true : false;
    // 業務前・中間・業務後に関わらず変更する値
    $('input[name="rollcall_method_type"]').on('change', function(e) {
        // 実施営業所は、実績かつ、「IT」「自動」「遠隔」の場合、編集不可
        let checkedMethodType = $('input[name="rollcall_method_type"]:checked');
        $('select[name="implement_section_id"]').prop('disabled', (!checkedMethodType.length || (checkedMethodType.val() > '2' && isExpectation === 'false')));
        // 自動点呼予定でない場合、中止ボタンをdisabledにする
        if (checkedMethodType.val() != '4' || isExpectation === 'false'){
            $('#rollcall-setting-modal-cancel-btn').prop('disabled', true);
        } else {
            $('#rollcall-setting-modal-cancel-btn').prop('disabled', false);
        }
    });

    // 業務後点呼の場合
    if (type == '3') {
        $(formId).find('.only-type-3').each(function() {
            $(this).removeClass('display-none');
        });
        $(formId).find('.only-type').each(function() {
            $(this).addClass('display-none');
        });
        $(formId).find('.only-type-1').each(function() {
            $(this).addClass('display-none');
        });
        /*
        点呼方法：自動の時は、「運行状況内容」「交替運転者連絡」入力項目非表示。指示事項（選択式）は表示。
         */
        let detail = $('#operation_status_detail-block');
        let notice = $('#alternate_driver_notice-block');
        // 初期表示
        if ($('input[name="rollcall_method_type"]:checked').val() === '4') {
            detail.hide();
            notice.hide();
        }
        // 切り替え時
        $('input[name="rollcall_method_type"]').on('change', function(e) {
            // 指示事項（選択形式・テキスト形式）の表示切替
            setInstruction($('input[name="rollcall_type"]:checked').val(), $('input[name="rollcall_method_type"]:checked').val());
            // 携行品disabled切替
            setBelonging(isExpectation, $('input[name="rollcall_type"]:checked').val(), $('input[name="rollcall_method_type"]:checked').val());
            // 自動選択時は、運行状況内容と交代運転者連絡は非表示となる
            if ($(this).val() === '4') {
                detail.find('input').val('');
                detail.hide();
                notice.find('input').val('');
                notice.hide();
            } else {
                detail.show();
                notice.show();
                // 業務前かつ自動以外は、予定点呼承認ボタン非活性（承認が必要な予定点呼：予定かつ自動かつ業務前かつ手動登録ではない）
                $(settingModalId).find('button[data-expectation-authorize-modal]').prop('disabled', true);
            }
        });
        // 予定実績の入力項目disabled制御（予定は、「点呼日時」「実施場所区分」「実施営業所」「実施予定場所」「指示事項」「点呼執行者」「点呼方法」「携行品」以外入力項目disabled）
        setDisabledByExpectation(type);
    } else if (type == '1') {
        // 乗務前点呼
        $(formId).find('.only-type-3').each(function() {
            $(this).addClass('display-none');
        });
        $(formId).find('.only-type').each(function() {
            $(this).removeClass('display-none');
        });
        $(formId).find('.only-type-1').each(function() {
            $(this).removeClass('display-none');
        });
        // 予定実績の入力項目disabled制御（予定は、「点呼日時」「実施場所区分」「実施営業所」「実施予定場所」「指示事項」「点呼執行者」「点呼方法」「その他事項」「携行品」以外入力項目disabled）
        setDisabledByExpectation(type);
        // 点呼方法 切り替え時
        $('input[name="rollcall_method_type"]').on('change', function(e) {
            // 指示事項（選択形式・テキスト形式）の表示切替
            setInstruction($('input[name="rollcall_type"]:checked').val(), $('input[name="rollcall_method_type"]:checked').val());
            // 携行品disabled切替
            setBelonging($('input[name="is_expectation"]').length && $('input[name="is_expectation"]:checked').val() == 1 ? true : false, $('input[name="rollcall_type"]:checked').val(), $('input[name="rollcall_method_type"]:checked').val());
            // 自動以外は予定点呼承認ボタン非活性（承認が必要な予定点呼：予定かつ自動かつ業務前かつ手動登録ではない）
            if ($(this).val() !== '4') {
                $(settingModalId).find('button[data-expectation-authorize-modal]').prop('disabled', true);
            } else {
                $(settingModalId).find('button[data-expectation-authorize-modal]').removeAttr('disabled');
            }
        });
    } else {
        $(formId).find('.only-type-3').each(function() {
            $(this).addClass('display-none');
        });
        $(formId).find('.only-type').each(function() {
            $(this).removeClass('display-none');
        });
        $(formId).find('.only-type-1').each(function() {
            $(this).addClass('display-none');
        });
        // 業務前かつ自動以外は、予定点呼承認ボタン非活性（承認が必要な予定点呼：予定かつ自動かつ業務前かつ手動登録ではない）
        $(settingModalId).find('button[data-expectation-authorize-modal]').prop('disabled', true);
    }

    // 予定実績の入力項目disabled制御（乗務前・乗務後）
    function setDisabledByExpectation(type)
    {
        let expectation_input_name = 'is_expectation';
        let is_expectation = $(formId).find('input[name="is_expectation"]');
        if (is_expectation.length === 0) {
            // 乗務前
            is_expectation = $(formId).find('input[name="before_is_expectation"]');
            expectation_input_name = 'before_is_expectation';
        }
        if (is_expectation.length === 0) {
            return;
        }
        // 点呼方法（自動・対面・TEL etc...）
        let method = is_expectation.data('method'); // default method_type
        let expectation = {
            expectation: function() {
                // 表示初期化
                // 点呼区分（前・中間・後）
                if ($('input[name="rollcall_type"]:checked').val() !== type) {
                    $('input[name="rollcall_type"]').parent('label').removeClass('active');
                    $('input[name="rollcall_type"]:checked').parent('label').addClass('active', true);
                }
                // 追加ボタンからの予定点呼登録時
                if (!$('input[name="id"]').val() && !$('input[name="relation_id"]').val() && $('input[name="rollcall_type"]:checked').val() != 1&& $('input[name="rollcall_type"]:checked').val() != 3) {
                    // 点呼区分が（業務前・業務後）ではない場合は乗務前に変更する
                    $('input[name="rollcall_type"][value="1"]').prop('checked', true).trigger('change');
                    $('input[name="rollcall_type"]').parent('label').removeClass('active');
                    $('input[name="rollcall_type"][value="1"]').parent('label').addClass('active', true);
                }
                // 点呼方法（自動・対面・TEL etc...）
                if ($('input[name="rollcall_method_type"]:checked').val() !== method) {
                    $('input[name="rollcall_method_type"]').parent('label').removeClass('active');
                    $('input[name="rollcall_method_type"]:checked').parent('label').addClass('active', true);
                }
                // 追加ボタンからの予定点呼登録時
                if (!$('input[name="id"]').val() && !$('input[name="relation_id"]').val()) {
                    // 新規の予定点呼では点呼区分（乗務前・乗務後）を変更可能とする
                    $('input[name="rollcall_type"]').prop('disabled', false);
                    $('input[name="rollcall_type"][value="2"]').prop('disabled', true);
                // それ以外の予定点呼登録時
                } else {
                    if (type != 1) {
                        // 各フォームをdisabledに
                        $(formId).find('input:not([type=hidden]),select,textarea').prop('disabled', true);
                    } else {
                        // 各フォームをdisabledに
                        $(formId).find('input:not([type=hidden]),select,textarea').not('.company-vehicle-select').prop('disabled', true);
                    }
                }

                // 乗務前/乗務後
                if (type == '1' || type == '3') {
                    // 日常点検・故障内容入力ボタンをdisabledに
                    $(formId).find('button[data-daily_check-select-modal]').prop('disabled', true);
                    $(settingModalId).find('button[data-malfunction-setting-modal]').first().prop('disabled', true);
                    // 指示事項（選択形式・テキスト形式）の表示切替
                    setInstruction($('input[name="rollcall_type"]:checked').val(), $('input[name="rollcall_method_type"]:checked').val());
                    // 予定点呼承認ボタン活性化（承認が必要な予定点呼：予定かつ自動かつ業務前かつ手動登録ではない）
                    $(settingModalId).find('button[data-expectation-authorize-modal]').removeAttr('disabled');
                }
                // 携行品disabled切替
                setBelonging(true, $('input[name="rollcall_type"]:checked').val(), $('input[name="rollcall_method_type"]:checked').val());

                $('input[name="is_manual"]').val(1);
                const rollcalled_at = $('input[name="rollcalled_at"]');
                // minDateとmaxDateの初期化
                rollcalled_at.data('datetimepicker').minDate(false);
                rollcalled_at.data('datetimepicker').maxDate(false);
                // minDateとmaxDateの再設定
                rollcalled_at.data('datetimepicker').minDate(rollcalled_at.data('min-date') || false);
                rollcalled_at.data('datetimepicker').maxDate(rollcalled_at.data('max-date') || false);

                // 予定時の入力可能項目
                $('input[name="is_expectation"]').prop('disabled', false);
                $('input[name="before_is_expectation"]').prop('disabled', false);
                $('input[name="rollcalled_at"]').prop('disabled', false);
                $('input[name="rollcall_method_type"]').prop('disabled', false);
                $('select[name="authorizer_id"]').prop('disabled', false);
                $('input[name="select_filter_section_authorizer_id"]').prop('disabled', false);
                $('textarea[name="instructions_for_after"]').prop('disabled', false);
                $('textarea[name="instructions"]').prop('disabled', false);
                $('input[name="generic_field_1"]').prop('disabled', false);
                $('select[name="implement_section_id"]').prop('disabled', false);
                $('input[name="place_type"]').prop('disabled', false);
                $('input[name="planned_location"]').prop('disabled', false);
                // 日付重複チェックにuser_idが必要disabled時はhiddenで保持する
                $('#rollcall-setting-modal-user_id_hidden').prop('disabled', false);
            },
            achievement: function() {
                // 使用可能に変更
                $(formId).find('input:disabled,select:disabled,textarea:disabled').prop('disabled', false);
                // permissionで変更不可の所属情報はdisabledにする
                $(formId).find('select[data-affiliation_permission_disabled="disabled"]').prop('disabled', true);
                // ログインアカウントが一般権限の場合は、運転者をdisabledにする
                $('#rollcall-setting-modal-user_id').prop('disabled', $('#rollcall-setting-modal-user_id').data('is_normal_user'));
                // 追加ボタンからの点呼実績登録時、日毎モーダル中間点呼の場合は、変更可能
                let rollcallTypeDisabled = false;
                if ($('input[name="relation_id"]').val() && type !== 2) {
                    // 点呼区分は変更不可
                    rollcallTypeDisabled = true;
                }
                $('input[name="rollcall_type"]').prop('disabled', rollcallTypeDisabled);
                // 実施営業所は、「IT」「自動」「遠隔」の場合、編集不可
                let rollcall_method_type = $('input[name="rollcall_method_type"]:checked');
                if (rollcall_method_type.val() > '2') {
                    $('select[name="implement_section_id"]').prop('disabled', true);
                }
                // 画面での実績登録時、点呼方法「IT」「自動」「遠隔」選択不可・選択解除(対面:1 TEL:2のみ可)
                $('input[name="rollcall_method_type"]').each(function(){
                    if ($(this).val() > '2') {
                        $(this).prop('disabled', true).parent('label').addClass('d-none');
                        $(this).prop('checked', false).trigger('change');
                    }
                });
                // 予定点呼承認ボタン非活性（承認が必要な予定点呼：予定かつ自動かつ業務前かつ手動登録ではない）
                $(settingModalId).find('button[data-expectation-authorize-modal]').prop('disabled', true);
                // 乗務前
                if (type == '1') {
                    // 日常点検・故障内容入力ボタンを使用可能に戻す
                    $(formId).find('button[data-daily_check-select-modal]').removeAttr('disabled');
                    $(settingModalId).find('button[data-malfunction-setting-modal]').first().removeAttr('disabled');
                }
                // 乗務後
                if (type == '3') {
                    // 故障内容入力ボタンを使用可能に戻す
                    $(settingModalId).find('button[data-malfunction-setting-modal]').first().removeAttr('disabled');
                }
                // 指示事項（選択形式・テキスト形式）の表示切替
                setInstruction($('input[name="rollcall_type"]:checked').val(), $('input[name="rollcall_method_type"]:checked').val());
                // 携行品disabled切替
                setBelonging(false, $('input[name="rollcall_type"]:checked').val(), $('input[name="rollcall_method_type"]:checked').val());
                // 日付重複チェックに使用するhiddenのuser_idは無効(disabled)にしておく
                $('#rollcall-setting-modal-user_id_hidden').prop('disabled', true);
                $('input[name="is_manual"]').val(0);
                // minDateとmaxDateの再設定
                const rollcalled_at = $('input[name="rollcalled_at"]');
                rollcalled_at.data('datetimepicker').minDate(false);
                rollcalled_at.data('datetimepicker').maxDate(rollcalled_at.data('now'));
            }
        }
        // 初期表示（予定）
        if ($('input[name="' + expectation_input_name + '"]:checked').val() === '1') {
            expectation.expectation();
        } else {
            expectation.achievement();
        }
        // 予定/実績切替
        is_expectation.off();
        is_expectation.on('change', function() {
            let methodTypeChecked = $('input[name="rollcall_method_type"]:checked').val();
            // 予定で「IT・遠隔・自動」がチェックされていて、実績に切り替えてチェックが外れ、再度予定へ戻った場合undefinedになる為、デフォルトの値を設定
            if (typeof(methodTypeChecked) === 'undefined') {
                $('input[name="rollcall_method_type"][value='+ method +']').prop('checked', true).trigger('change');
            }

            // 実績
            if ($(this).val() === '0') {
                // 実績
                expectation.achievement();
            } else {
                // 予定
                expectation.expectation();
                // 点呼方法制御を元に戻す
                $('input[name="rollcall_method_type"]').each(function() {
                    $(this).prop('disabled', false).parent('label').removeClass('d-none');
                    if ($(this).val() === methodTypeChecked) {
                        $(this).prop('checked', true).trigger('change');
                    }
                });
            }
        })
    }

    // 乗務前用 指示事項（選択形式・テキスト形式）の入力切替
    function setInstruction(rollcall_type, method_type)
    {
        if (rollcall_type == 3) {
            // 業務後
            // テキスト形式 表示
            $(settingModalId).find('[name=instructions_for_after]').prop('disabled', false).closest("[class*='only-type']").removeClass('display-none');
            // 選択形式 非表示
            $(settingModalId).find('[name="new_instructions[]"]').prop('disabled', true).closest("[class*='only-type']").addClass('display-none');
            // multiple-selectを使用不可に変更
            $(settingModalId + ' .instruction-multiple-select').find('input').prop('disabled', true);
            // 業務前 非表示
            $(settingModalId).find('[name=instructions_for_before]').prop('disabled', true).closest("[class*='only-type']").addClass('display-none');
        } else if (rollcall_type == 1 && method_type == '4') {
            // 点呼方法：業務前自動
            // テキスト形式 非表示
            $(settingModalId).find('[name=instructions_for_before]').prop('disabled', true).closest("[class*='only-type']").addClass('display-none');
            // 選択形式 表示
            $(settingModalId).find('[name="new_instructions[]"]').prop('disabled', false).closest("[class*='only-type']").removeClass('display-none');
            // multiple-selectを使用可能に変更
            $(settingModalId + ' .instruction-multiple-select').find('input:disabled').prop('disabled', false);
            // 業務後 非表示
            $(settingModalId).find('[name=instructions_for_after]').prop('disabled', true).closest("[class*='only-type']").addClass('display-none');
        } else {
            // 点呼方法：上記以外
            // テキスト形式 非表示
            $(settingModalId).find('[name=instructions_for_before]').prop('disabled', true).closest("[class*='only-type']").addClass('display-none');
            // 選択形式 表示
            $(settingModalId).find('[name="new_instructions[]"]').prop('disabled', false).closest("[class*='only-type']").removeClass('display-none');
            // multiple-selectを使用可能に変更
            $(settingModalId + ' .instruction-multiple-select').find('input:disabled').prop('disabled', false);
            // 業務後 非表示
            $(settingModalId).find('[name=instructions_for_after]').prop('disabled', true).closest("[class*='only-type']").addClass('display-none');
        }
    }

    // 携行品の入力切替
    function setBelonging(is_expectation, rollcall_type, method_type)
    {
        // 携行品は以下で使用可能。それ以外は非表示 もしくは disabled
        // 【実績】点呼区分：乗務前・中間・乗務後  かつ  点呼方法：対面1・TEL2
        // 【予定】点呼区分：乗務前            かつ  点呼方法：対面1・TEL2・自動4
        let belongingSelect = $(settingModalId + ' .belonging-multiple-select');
        let belongingOptions = $(settingModalId + ' .belonging-multiple-select').find('input');
        if (!belongingSelect) {
            return;
        }
        // 乗務前
        if (rollcall_type == 1) {
            // 予定  かつ  点呼方法：対面1・TEL2・自動4
            // 実績  かつ  点呼方法：対面1・TEL2
            if ((is_expectation && ['1', '2', '4'].includes(method_type))
            || (!is_expectation && ['1', '2'].includes(method_type))) {
                belongingSelect.prop('disabled', false);
                belongingOptions.prop('disabled', false);
                return;
            }

        // 中間
        } else if (rollcall_type == 2 && !is_expectation && ['1', '2'].includes(method_type)) {
            // 実績  かつ  点呼方法：対面1・TEL2
            belongingSelect.prop('disabled', false);
            belongingOptions.prop('disabled', false);
            return;

        // 乗務後
        } else if (rollcall_type == 3 && ['1', '2'].includes(method_type)) {
            // 点呼方法：対面1・TEL2（実績・予定）
            belongingSelect.prop('disabled', false);
            belongingOptions.prop('disabled', false);
            return;
        }

        belongingSelect.prop('disabled', true);
        belongingOptions.prop('disabled', true);
    }
}

/**
 * 点呼設定モーダル表示時のイベント設定
 */
window.rollcall_config_event_set = function () {

    function isExpectationChanged()
    {
        let enforcer = $('select[name="expectation_enforcer_id"]');
        let enforcer2 = $('select[name="expectation_enforcer_id2"]');
        let hours_val = $('input[name="expectation_hours"]');
        let hours = hours_val.prev('input');
        const isExpectation = ($('input[name="is_expectation"]:checked').val() === '1');
        // selectがdisabled時のhidden無効
        $('input[name="expectation_enforcer_id"]:hidden').prop('disabled', true);
        $('input[name="expectation_enforcer_id2"]:hidden').prop('disabled', true);
        if (isExpectation) {
            enforcer.prop('disabled', false).val(enforcer.data('default')).trigger("change");
            enforcer2.prop('disabled', false).val(enforcer2.data('default')).trigger("change");
            hours.prop('disabled', false).val(hours.data('prefix') + hours.data('default') + hours.data('suffix'))
            hours_val.val(hours.data('default'));
        } else {
            enforcer.prop('disabled', true).val('').trigger("change");
            enforcer2.prop('disabled', true).val('').trigger("change");
            hours.prop('disabled', true).val('');
            hours_val.val('');
        }
    }

    /*
    業務後点呼実施予定ON/OFFによる予定関連項目制御
     */
    $(document).on('change', 'input[name="is_expectation"]', function(e) {
        isExpectationChanged();
    });
    isExpectationChanged();

    /*
    業務前点呼実施予定ON/OFFによる予定関連項目制御
     */
    $(document).on('change', 'input[name="before_is_expectation"]', function(e) {
        let enforcer = $('select[name="before_expectation_enforcer_id"]');
        let enforcer2 = $('select[name="before_expectation_enforcer_id2"]');
        let hours_val = $('input[name="before_expectation_hours"]');
        let hours = hours_val.prev('input');
        // selectがdisabled時のhidden無効
        $('input[name="before_expectation_enforcer_id"]:hidden').prop('disabled', true);
        $('input[name="before_expectation_enforcer_id2"]:hidden').prop('disabled', true);

        if ($(this).val() === '1') {
            enforcer.prop('disabled', false).val(enforcer.data('default')).trigger("change");
            enforcer2.prop('disabled', false).val(enforcer2.data('default')).trigger("change");
            hours.prop('disabled', false).val(hours.data('prefix') + hours.data('default') + hours.data('suffix'))
            hours_val.val(hours.data('default'));
        } else {
            enforcer.prop('disabled', true).val('').trigger("change");
            enforcer2.prop('disabled', true).val('').trigger("change");
            hours.prop('disabled', true).val('');
            hours_val.val('');
        }
    });
}

/**
 * 点呼登録フォーム 点呼簿カスタマイズ項目
 */
window.rollcall_setting_form_customize_option_set = function (pageId, immediate = false) {

    /*---- 点呼登録画面 ----*/

    // 直前まで選択されていた営業所
    let prevSectionId = null;
    // 登録モーダル画面表示時
    if (pageId === 'remote_rollcall-join-modal') {
        $(`#${pageId}`).off('show.bs.modal.customizeOption');
        $(`#${pageId}`).on('show.bs.modal.customizeOption', function () {
            prevSectionId = null;
            updateCustomizeOption(pageId);
        });
    } else {
        $(document).off('show.bs.modal.customizeOption', `#${pageId}`);
        $(document).on('show.bs.modal.customizeOption', `#${pageId}`, function () {
            prevSectionId = null;
            updateCustomizeOption(pageId);
        });
    }
    // 点呼予定変更時
    $(document).off('change.customizeOption', `[id*="${pageId}-is_expectation"]`);
    $(document).on('change.customizeOption', `[id*="${pageId}-is_expectation"]`, function() {
        updateCustomizeOption(pageId);
    });
    // グループ会社・営業所変更時
    $(document).off('change.customizeOption', `#${pageId}-holding_id`);
    $(document).on('change.customizeOption', `#${pageId}-holding_id`, function () {
        updateCustomizeOption(pageId);
    });
    $(document).off('change.customizeOption', `#${pageId}-section_id`);
    $(document).on('change.customizeOption', `#${pageId}-section_id`, function () {
        updateCustomizeOption(pageId);
    });
    // 点呼区分変更時
    $(document).off('change.customizeOption', `[id*="${pageId}-rollcall_type"]`);
    $(document).on('change.customizeOption', `[id*="${pageId}-rollcall_type"]`, function() {
        const value = $(this).val();
        switchCustomizeOption(pageId, null, value, null);
    });
    // 点呼パターン変更時
    $(document).off('change.customizeOption', `[id*="${pageId}-operation_type"]`);
    $(document).on('change.customizeOption', `[id*="${pageId}-operation_type"]`, function() {
        const value = $(this).val();
        switchCustomizeOption(pageId, 'rollcall-setting-customize-options-modal', null, value);
    });

    // カスタマイズ項目更新
    function updateCustomizeOption(pageId) {
        const optionForm = $(`#${pageId}-customize-option-form`);
        const isExpectation = !!($(`[id*="${pageId}-is_expectation"]`).length && $(`[id*="${pageId}-is_expectation"]:checked`).val() == 1);
        if (isExpectation) {
            optionForm.empty();
            prevSectionId = null;
        } else {
            const selectedSectionId = $(`#${pageId}-section_id`).val();
            const selectedOperationType = $(`input[id*="${pageId}-operation_type"]:checked`).val();

            if (selectedSectionId?.length > 0){
                // 選択された営業所に変更があった場合のみフォーム更新
                if (selectedSectionId !== prevSectionId) {
                    const action = optionForm.data('action');
                    const datas = {
                        'id': $(`#${pageId}-id`).val(),
                        'holding_id': $(`#${pageId}-holding_id`).val(),
                        'company_id': $(`#${pageId}-company_id`).val(),
                        'section_id': selectedSectionId,
                        'operation_type': selectedOperationType,
                        'page_id': pageId,
                        'is_disabled': optionForm.attr('data-is_disabled') ?? 'false',
                    };
                    _ajax.post(action, datas, function(results) {
                        const json_results = JSON.parse(results);
                        const form = formatCustomizeOptionFormHtml(pageId, json_results.customizeOptionForm, json_results.snapshot);

                        optionForm.empty();
                        optionForm.html(form);
                        // 点呼区分等の初回同期(ajaxA)が既に完了している場合は、
                        // 「カスタマイズ項目設定」ボタンをこの時点で有効化する。
                        // (未完了の場合はremote_rollcall_meeting.js側の同期完了時に
                        //  有効化されるため、ここでは何もしない)
                        if ($(`#${pageId}`).data('customizeOptionSynced')) {
                            optionForm.find('[data-rollcall-setting-customize-options-modal]').prop('disabled', false);
                        }
                        switchCustomizeOption(pageId, null, null, null);
                        // バリデーションエラーを監視
                        attachValidErrorSummaryObserver(pageId);
                    }, function(xhr, status, errorThrown){
                        _error.omitted(xhr, status, errorThrown);
                        optionForm.empty();
                    }, 'html');
                }
            } else {
                optionForm.empty();
            }
            prevSectionId = selectedSectionId;
        }
    }
    // カスタマイズ項目フォームの表示用HTMLを加工して返す
    function formatCustomizeOptionFormHtml(pageId, formInnerHtml, snapshot) {
        if (!formInnerHtml) {
            return '';
        }

        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = formInnerHtml;
        // ツールチップアイコン表示
        tempDiv = createRollcallPatternTooltipIcon(pageId, tempDiv);
        // ラベル文言置き換え
        tempDiv = rewriteCustomizeOptionLabel(pageId, tempDiv, snapshot);
        return tempDiv.innerHTML;
    }
    // 点呼パターンのツールチップアイコン表示
    function createRollcallPatternTooltipIcon(pageId, form) {
        const operationTypeCount = form.querySelectorAll('[name="operation_type"]').length;
        if (operationTypeCount >= 2) {
            const label = form.querySelector(`label[for^="${pageId}-operation_type"]`);
            if (label) {
                const tooltipMessage = form.querySelector('[data-rollcall-pattern-tooltip]')?.dataset.rollcallPatternTooltip ?? '';
                const tooltipIcon = `<i class="fa fa-question-circle ml-1 pb-2" role="button" data-toggle="tooltip" data-html="true" title="${tooltipMessage}"></i>`;
                label.parentElement.style.display = 'flex';
                label.parentElement.style.alignItems = 'center';
                label.insertAdjacentHTML('afterend', tooltipIcon);
            }
        }
        return form;
    }
    // ラベル文言書き換え
    function rewriteCustomizeOptionLabel(pageId, form, snapshot) {
        // カスタマイズ項目のラベルすべて
        form.querySelectorAll(`label[for^="${pageId}-customize-option-content"]`)?.forEach(option => {
            // ラベルが指す id を取得
            const optionId = option.getAttribute('for');

            // idから点呼区分・点呼パターン・点呼内容マスタIDを取得
            const parts = optionId.split('_');
            // パーツが足りなければ次へ
            if (parts.length < 4) return;
            const [rollcallType, operationType, contentId] = parts.slice(-3);

            // スナップショットから該当の要素取得
            let targetContent = [];
            for (const item of snapshot['sheet_settings'] ?? []) {
                const contents = item.contents ?? [];
                // 点呼区分と点呼パターンが一致しているか
                if (contents &&
                    item.rollcall_type == rollcallType && item.operation_type == operationType) {
                    // 点呼内容マスタIDが一致しているか
                    for (const content of contents) {
                        if (content.content_id == contentId) {
                            // 見つけたら抜ける
                            targetContent = content;
                            break;
                        }
                    }
                    // 見つけていたら抜ける
                    if (targetContent) {
                        break;
                    }
                }
            }
            if (targetContent) {
                const text = targetContent.report_label ?? targetContent.label;
                if (text) {
                    option.textContent = text;
                }
            }
        });
        return form;
    }
    // 表示カスタマイズ項目切り替え
    function switchCustomizeOption(pageId, modalId = null, rollcallType = null, operationType = null) {
        if (!modalId) {
            modalId = pageId
        }
        if (!rollcallType) {
            rollcallType = $(`input[id*="${pageId}-rollcall_type"]:checked`).val();
        }
        if (!operationType) {
            operationType = $(`input[id*="${pageId}-operation_type"]:checked`).val();
        }
        // モーダル取得
        const modal = $(`#${modalId}`);
        if (modal) {
            const isDisabled = (modal.find(`#${pageId}-customize-option-form`).attr('data-is_disabled') ?? 'false') === 'true';
            modal.find('.customize-option-contents').each(function() {
                // 点呼区分・点呼パターンが一致する要素のみ表示
                const matches = $(this).attr('data-rollcall_type') == rollcallType &&
                                $(this).attr('data-operation_type') == operationType;
                $(this).toggleClass('d-none', !matches);
                $(this).find(`[name^="customize-option-content"]`).prop('disabled', isDisabled || !matches);
            });
        }
        showValidErrorSummary(modalId);
    }

    /*---- カスタマイズ項目登録モーダル画面 ----*/

    // モーダル表示ボタン押下時
    $(document).off('click.customizeOption', '[data-rollcall-setting-customize-options-modal]');
    $(document).on('click.customizeOption', '[data-rollcall-setting-customize-options-modal]', function() {
        _modal.create(this, 'rollcall-setting-customize-options-modal', ['page_id']);
    });
    // モーダル表示時
    $(document).off('show.bs.modal.customizeOption', '#rollcall-setting-customize-options-modal');
    $(document).on('show.bs.modal.customizeOption', '#rollcall-setting-customize-options-modal', function () {
        const parentPageId = $(this).find('#rollcall-setting-customize-options-modal-parent_page_id').val();
        const fromForm = $(`#${parentPageId}-customize-option-contents-box`);
        const toForm = $(this).find('#rollcall-setting-customize-options-modal-customize-option-contents-box');
        toForm.empty();
        // 親画面のカスタマイズ項目から移動
        fromForm.children().appendTo(toForm);
        fromForm.empty();
    });
    // モーダル非表示時
    $(document).off('hidden.bs.modal.customizeOption', '#rollcall-setting-customize-options-modal');
    $(document).on('hidden.bs.modal.customizeOption', '#rollcall-setting-customize-options-modal', function () {
        // ツールチップ削除
        $('[data-toggle="tooltip"]').tooltip('hide');
        const parentPageId = $(this).find('#rollcall-setting-customize-options-modal-parent_page_id').val();
        const fromForm = $(this).find('#rollcall-setting-customize-options-modal-customize-option-contents-box');
        const toForm = $(`#${parentPageId}-customize-option-contents-box`);
        toForm.empty();
        // 親画面のカスタマイズ項目から移動
        fromForm.children().appendTo(toForm);
        fromForm.empty();
    });
    // input_type が number の項目の入力制御
    $(document).off('blur.customizeOption', `input[id*="${pageId}-customize-option-content_number"]`);
    $(document).on('blur.customizeOption', `input[id*="${pageId}-customize-option-content_number"]`, function() {
        let value = $(this).val().trim();
        const maxInt = $(this).data('max-int');
        const maxDec = $(this).data('max-dec');
        if (value === '' || !maxInt || !maxDec) return;

        value = value.replace(/[^0-9.]/g, '');
        const parts = value.split('.');
        let integerPart = parts[0] ?? '';
        let decimalPart = parts[1] ?? '';
        // 整数部桁数そろえる
        if (integerPart.length > 0) {
            integerPart = integerPart.slice(0, maxInt);
        }
        // 小数部桁数そろえる
        if (decimalPart.length > 0) {
            decimalPart = decimalPart.slice(0, maxDec);
        }
        // 整数部と小数部を合体して表示
        const formatted = Number(integerPart + '.' + decimalPart);
        $(this).val(formatted);
        $(this).siblings('.number-input-value').val(formatted);
    });
    // input_type が select_multiple の項目変更時（共通処理（common/select.js）の後続処理として動作する）
    $(document).off('mousedown.customizeOption', `select[id*="${pageId}-customize-option-content_select_multiple"]`);
    $(document).on('mousedown.customizeOption', `select[id*="${pageId}-customize-option-content_select_multiple"]`, function(e) {
        // 現在のスクロール位置取得
        const select = this;
        const scrollTop = select.scrollTop;

        e.preventDefault();
        $(this).trigger('focus');
        // 未選択の要素の selected を削除
        $(this).find('option').each(function () {
            if (!this.selected) {
                $(this).removeAttr('selected');
            }
        });
        // ブラウザの自動スクロール対策
        setTimeout(function () {
            select.scrollTop = scrollTop;
        }, 0);
    });
    // 選択解除 押下時（共通処理（common/select.js）の後続処理として動作する）
    $(document).off('click.customizeOption', '.customize-option-contents .select-reset');
    $(document).on('click.customizeOption', '.customize-option-contents .select-reset', function () {
        $(this).parent('.select-multiple--label').siblings('select').find('option').removeAttr('selected');
    });

    // カスタマイズ項目バリデーションエラーサマリ表示
    function showValidErrorSummary(pageId) {
        const summary = $('#invalid-feedback-summary');
        if (summary.length) {
            const contentsBox = $(`#${pageId}-customize-option-contents-box`);
            const allErrorCount = contentsBox.length
                ? contentsBox.find('.errors span.invalid-feedback').filter(function() {
                    return $(this).text().trim() !== '';
                }).length
                : 0;
            // カスタマイズ項目
            const contentAreas = contentsBox.find('.customize-option-contents');
            let errorCount = 0;
            if (contentAreas.length) {
                // カスタマイズ項目以外のバリデーションエラー件数取得
                errorCount += allErrorCount - contentAreas.find('.errors span.invalid-feedback').filter(function() {
                    return $(this).text().trim() !== '';
                }).length;

                // アクティブなカスタマイズ項目からバリデーションエラー件数取得
                errorCount += contentAreas.not('.d-none').find('.errors span.invalid-feedback').filter(function() {
                    return $(this).text().trim() !== '';
                }).length;
            }

            if (errorCount > 0) {
                const template = summary.data('template');
                const message = template.replace('{count}', errorCount);
                summary.find('.invalid-feedback-text').text(message);
            } else {
                summary.find('.invalid-feedback-text').text('');
            }
        }
    }
    // カスタマイズ項目のバリデーションエラー表示タグを監視
    var observer = null;
    function attachValidErrorSummaryObserver(pageId) {
        // 古いオブザーバー削除
        if (observer) {
            observer.disconnect();
            observer = null;
        }
        // カスタマイズ項目フォーム取得
        const form = $(`#${pageId}-customize-option-contents-box`)[0];
        if (!form) {
            return;
        }

        observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // バリデーションエラー文言の生成・削除の場合、エラーサマリ表示更新
                if (mutation.addedNodes.length && $(mutation.addedNodes).hasClass('invalid-feedback') ||
                    mutation.removedNodes.length && $(mutation.removedNodes).hasClass('invalid-feedback')) {
                    showValidErrorSummary(pageId); 
                }
            });
        });

        observer.observe(form, { 
            childList: true, 
            subtree: true 
        });
    }

    // 即時実行
    if (immediate) {
        prevSectionId = null;
        updateCustomizeOption(pageId);
    }
}
